import { Component } from '@angular/core';

@Component({
  selector: 'app-customer-sales-analysis-by-location',
  standalone: false,
  
  templateUrl: './customer-sales-analysis-by-location.component.html',
  styles: ``
})
export class CustomerSalesAnalysisByLocationComponent {

}
